'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _basket = require('redux/actions/basket');

var _modal = require('redux/actions/modal');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _modal_type = require('redux/actions/modal_type');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _catalog = require('redux/actions/catalog');

var _helpers = require('helpers');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AddToBasket: {
        displayName: 'AddToBasket'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/AddToBasket/AddToBasket.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AddToBasket = _wrapComponent('AddToBasket')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        orderInOneClick: state.setting.orderInOneClick,
        buyInCreditActive: state.setting.buyInCreditActive,
        buyInCredit: state.setting.buyInCredit,
        addBasketButtonName: state.setting.addBasketButtonName,
        addBasketButtonOneClickName: state.setting.addBasketButtonOneClickName,
        user: state.auth.user,
        basketElements: state.basket.items,
        currency: state.currency,
        lang: state.lang
    };
}, { addProduct: _basket.addProduct, showModal: _modal.showModal, hide: _modal.hide, push: _reactRouterRedux.push, showModalAuth: _modal_type.showModalAuth, createOrder: _basket.createOrder, clearBasket: _basket.clearBasket, showModalAuthOneClick: _modal_type.showModalAuthOneClick, showModifierModal: _modal_type.showModifierModal, getProduct: _catalog.getProduct }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(AddToBasket, _Component);

    function AddToBasket(props) {
        (0, _classCallCheck3.default)(this, AddToBasket);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddToBasket.__proto__ || (0, _getPrototypeOf2.default)(AddToBasket)).call(this));

        _this.showErrorAlert = function (message) {
            _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 3000 });
        };

        _this.onAddToCartCallback = function (e) {
            var lang = _this.props.lang;


            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0 && !_this.props.isModal || _this.props.product.is_quantity_change && !_this.props.isModal) {
                var modNames = [];
                if (_this.props.product.modifier[0] !== undefined) {
                    modNames.push(_this.props.product.modifier[0].name);
                }
                if (_this.props.product.modifier[1] !== undefined) {
                    modNames.push(_this.props.product.modifier[1].name);
                }
                if (_this.props.product.modifier[2] !== undefined) {
                    modNames.push(_this.props.product.modifier[2].name);
                }
                var choose = lang['store.add_to_cart.choose'];
                var copyProduct = JSON.parse((0, _stringify2.default)(_this.props.product));
                _this.props.showModifierModal(copyProduct, choose + ' ' + modNames.join(', '), _this.props.count);
            } else {
                if (_this.props.isModal) {
                    _this.props.close();
                }
                if (_this.props.updateProducts) {
                    _promise2.default.all(_this.props.updateProducts()).then(function (resp) {
                        var addingProd = resp.filter(function (item) {
                            return item.offers.find(function (elem) {
                                return elem.id === _this.props.product.id;
                            });
                        });
                        if (addingProd.length > 0) {
                            _LocalStorageProxy2.default.removeItem('buy_in_credit');
                            _this.addToCart(e);
                        } else {
                            _this.showErrorAlert(lang['store.add_to_cart.item_not_exist']);
                        }
                    });
                } else {
                    _LocalStorageProxy2.default.removeItem('buy_in_credit');
                    _this.addToCart(e);
                }
            }
        };

        _this.onBuyInOneClickCallback = function (e) {
            var isBuyInCredit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props,
                lang = _this$props.lang,
                product = _this$props.product;


            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0 && !_this.props.isModal || _this.props.product.is_quantity_change && !_this.props.isModal) {
                var modNames = [];
                if (product.modifier[0] !== undefined) {
                    modNames.push(product.modifier[0].name);
                }
                if (product.modifier[1] !== undefined) {
                    modNames.push(product.modifier[1].name);
                }
                if (product.modifier[2] !== undefined) {
                    modNames.push(product.modifier[2].name);
                }
                var choose = lang['store.add_to_cart.choose'];
                var copyProduct = JSON.parse((0, _stringify2.default)(product));
                _this.props.showModifierModal(copyProduct, choose + ' ' + modNames.join(', '));
            } else {
                _this.props.clearBasket();
                if (_this.props.user) {
                    if (isBuyInCredit === true) {
                        _LocalStorageProxy2.default.setItem('buy_in_credit', 'true');
                    } else {
                        _LocalStorageProxy2.default.removeItem('buy_in_credit');
                    }
                    _this.addToCart(e);
                    _this.callCreateOrder();
                    if (_this.props.isModal) {
                        _this.props.close();
                    }
                } else {
                    if (isBuyInCredit === true) {
                        _LocalStorageProxy2.default.setItem('buy_in_credit', 'true');
                    } else {
                        _LocalStorageProxy2.default.removeItem('buy_in_credit');
                    }
                    _this.addToCart(e);
                    _this.setState({ wasOrderClick: true });
                    if (_this.props.isModal) {
                        _this.props.showModalAuthOneClick(true);
                    } else {
                        _this.props.showModalAuthOneClick(true);
                    }
                }
            }
        };

        _this.callCreateOrder = function () {
            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;

            _this.props.push('/basket');
            _this.props.createOrder(_this._compileOrder(basketElements)).then(function (result) {
                _this.props.clearBasket();
                _this.props.push('/create-order/' + result.result.order_id);
            }).catch(function (err) {
                //Ошибка "предложение не найдено"
                if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
                    console.log('предложение не найдено', err);
                    err.dataError.forEach(function (item) {
                        _this.props.deleteProduct(item);
                    });

                    var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];

                    setTimeout(function () {
                        _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                    }, 0);
                }

                //Ошибка: алкогольные товары в корзине
                if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
                    _this._showAlcoWarning(err.dataError);
                }
            });
        };

        _this._compileOrder = function () {
            var product = _this.props.product;
            var count = _this.props.count || 1;
            var sum = 0;
            var products = [];
            sum += product.price * count;
            products.push({
                offer_id: product.id,
                quantity: count,
                price: product.price,
                modifier_option_id: product.modifier_option_id,
                modifier_option_name: product.modifierName,
                nestedOffers: product.nestedOffers
            });

            var userAgent = navigator.userAgent || '';
            var utmRedirectData = _LocalStorageProxy2.default.getItem('utm_redirect_data') || '';
            _LocalStorageProxy2.default.setItem('utm_redirect_data', '');
            var currency_id = _this.props.currency.id;
            return { sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id };
        };

        _this.addToCart = function (event) {
            var ModalContent = _helpers.ThemeHelper.getViewForComponent('ModalContent', null, { folderName: 'Basket/AddToBasket' });
            var product = _this.props.product;
            var count = _this.props.count || 1;
            var remainderQuantity = null;
            if (_this.state.customFields) {
                var isError = false;
                _this.state.customFields.forEach(function (customField) {
                    if (customField.isRequired && (customField.value == null || customField.value == '')) {
                        isError = true;
                        var alertMessage = _this.props.lang['store.customFields.error.required'] + customField.name;
                        setTimeout(function () {
                            _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                        }, 0);
                        return null;
                    }
                    if (customField.onlyLatin) {
                        var regexp = /^[0-9A-Za-z @_-]+$/;
                        var result = !regexp.test(customField.value);
                        if (result) {
                            isError = true;
                            var _alertMessage = _this.props.lang['store.customFields.error.noLatin'] + customField.name;
                            setTimeout(function () {
                                _reactSAlert2.default.error(_alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                            }, 0);
                            return null;
                        }
                    }
                    var matches = customField.value.match(/\S+/g) || [];
                    if (customField.maxWords && matches.length > customField.maxWords * 1) {
                        isError = true;
                        var _alertMessage2 = _this.props.lang['store.customFields.error.noLatin'] + customField.name;
                        setTimeout(function () {
                            _reactSAlert2.default.error(_alertMessage2, { position: 'top-right', effect: 'slide', timeout: 7000 });
                        }, 0);
                        return null;
                    }
                });
                if (isError) {
                    return null;
                }
            }

            if (product.modifier_option_id !== undefined && product.modifier_option_id !== null && product.modifier_option.storable && product.modifier_option.storage_strict && product.modifier_option.remainder[0] && product.type_id !== 5) {
                _this.props.getProduct(product.id).then(function (result) {
                    product.modifier_option = result.modifiedOption.filter(function (value) {
                        return value.id === product.modifier_option_id;
                    })[0];
                    remainderQuantity = product.modifier_option.remainder[0].quantity;
                    _this.props.addProduct({
                        description: product.description,
                        id: product.id,
                        name: product.name,
                        price: parseFloat(product.price),
                        picture: product.pictures ? product.pictures[0] : {},
                        count: count,
                        type_id: product.type_id,
                        modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
                        modifier_option: product.modifier_option,
                        remainder_quantity: remainderQuantity,
                        modifier_option_name: product.modifierName,
                        custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
                    });
                    if (_this.props.isModal) {
                        _this.props.product.modifier_option_id = undefined;
                    }
                });
            } else if (product.modifier_option_id === undefined && product.storable && product.storage_strict && product.remainder[0] && product.type_id !== 5) {
                _this.props.getProduct(product.id).then(function (result) {
                    product = result;
                    remainderQuantity = product.remainder[0].quantity;
                    _this.props.addProduct({
                        description: product.description,
                        id: product.id,
                        name: product.name,
                        price: parseFloat(product.price),
                        picture: product.pictures ? product.pictures[0] : {},
                        count: count,
                        type_id: product.type_id,
                        modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
                        modifier_option: null,
                        remainder_quantity: remainderQuantity,
                        custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
                    });
                });
            } else if (product.storable && product.remainder[0] && product.type_id === 5) {
                _this.props.getProduct(product.id).then(function (result) {
                    var quantityTechCard = 1;
                    result.remainder = [];
                    var childOffers = [];
                    var childOffer = void 0;
                    var childOffersTwo = [];
                    var childOfferTwo = void 0;
                    var quantity = void 0;
                    result.nestedOffers.forEach(function (nestedOffer) {
                        product.nestedOffers.forEach(function (actualNestedOffer) {
                            if (actualNestedOffer.id === nestedOffer.id) {
                                nestedOffer.quantity = actualNestedOffer.quantity;
                            }
                        });
                        if (nestedOffer.quantity > 0) {
                            if (nestedOffer.childOffer.type_id === 5) {
                                nestedOffer.childOffer.remainder = [];
                                nestedOffer.childOffer.storable = false;
                                nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                                    _this.getRemainder(nestedOfferTwo, nestedOffer.quantity, result);
                                });
                            } else {
                                _this.getRemainder(nestedOffer, quantityTechCard, result);
                            }
                        }
                    });
                    remainderQuantity = result.remainder[0].quantity;
                    _this.props.addProduct({
                        description: product.description,
                        id: product.id,
                        name: product.name,
                        price: parseFloat(product.price),
                        picture: product.pictures ? product.pictures[0] : {},
                        count: count,
                        type_id: product.type_id,
                        modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
                        modifier_option: product.modifier_option,
                        remainder_quantity: remainderQuantity,
                        modifier_option_name: product.modifierName,
                        nested_offer: product.nestedOffers,
                        values_mods: product.valuesMods,
                        custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
                    });
                });
            } else {
                _this.props.addProduct({
                    description: product.description,
                    id: product.id,
                    name: product.name,
                    price: parseFloat(product.price),
                    picture: product.pictures ? product.pictures[0] : {},
                    count: count,
                    type_id: product.type_id,
                    modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
                    modifier_option: product.modifier_option,
                    remainder_quantity: remainderQuantity,
                    modifier_option_name: product.modifierName,
                    nested_offer: product.nestedOffers,
                    values_mods: product.valuesMods,
                    custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
                });
                if (_this.props.isModal) {
                    _this.props.product.modifier_option_id = undefined;
                }
            }
            var cart = $('.ibonus-shopping-cart');
            var imgtodrag = event.target ? $(event.target).parents("div.flying-to-cart-holder").find("img.flying-to-cart-img").eq(0) : null;

            if (imgtodrag && _this.props.isModal !== true) {
                var imgclone = imgtodrag.clone().offset({
                    top: imgtodrag.offset().top,
                    left: imgtodrag.offset().left
                }).css({
                    'opacity': '0.7',
                    'position': 'absolute',
                    'height': imgtodrag.height(),
                    'width': imgtodrag.width(),
                    'z-index': '1200'
                }).appendTo($('body')).animate({
                    'top': cart.offset().top + 10,
                    'left': cart.offset().left + 10,
                    'width': 30,
                    'height': 30
                }, 1000, 'easeInOutExpo');

                imgclone.animate({
                    'width': 0,
                    'height': 0
                }, function () {
                    $(this).detach();
                });
            }
        };

        _this.changeCustomFields = function (e) {
            _this.state.customFields[e.target.id].value = e.target.value;
            _this.setState({ customFields: _this.state.customFields });
        };

        var customFields = null;
        var additionalInfo = props.product.additional_info ? JSON.parse(props.product.additional_info) : null;
        if (additionalInfo !== null && additionalInfo.customFields) {
            customFields = additionalInfo.customFields;
            customFields.map(function (item) {
                if (!item.value) {
                    item.value = null;
                }
                return item;
            });
        }
        _this.state = {
            wasOrderClick: false,
            customFields: customFields
        };
        return _this;
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     if (this.state.wasOrderClick && this.props.user) {
    //         this.callCreateOrder();
    //         this.setState({wasOrderClick: false});
    //         return false;
    //     }
    //
    //     if (this.state.wasOrderClick) {
    //         this.setState({wasOrderClick: false});
    //     }
    //
    //     return true;
    // };

    (0, _createClass3.default)(AddToBasket, [{
        key: 'getRemainder',
        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
            var _this2 = this;

            if (nestedOffer.childOffer === null) {
                return null;
            }
            if (nestedOffer.quantity > 0) {
                var quantity = void 0;
                var quantityTechCard = void 0;
                quantity = nestedOffer.quantity;
                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
                            return modifier;
                        }
                        return mod;
                    }, null);
                }
                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.type_id === 5) {
                    nestedOffer.childOffer.remainder = [];
                    nestedOffer.childOffer.storable = false;
                    quantity = nestedOffer.quantity * quantityParent;
                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('AddToBasket', null, { folderName: 'Basket/AddToBasket' });

            var _props = this.props,
                product = _props.product,
                className = _props.className,
                callback = _props.callback,
                addProduct = _props.addProduct,
                count = _props.count,
                lang = _props.lang,
                props = (0, _objectWithoutProperties3.default)(_props, ['product', 'className', 'callback', 'addProduct', 'count', 'lang']);


            return _react3.default.createElement(View, (0, _extends3.default)({
                callback: this.onAddToCartCallback,
                className: className,
                callbackOneClick: this.onBuyInOneClickCallback
            }, props, {
                product: product,
                count: count,
                customFields: this.state.customFields,
                changeCustomFields: this.changeCustomFields,
                lang: lang
            }));
        }
    }]);
    return AddToBasket;
}(_react2.Component), _class2.propTypes = {
    updateProducts: _react2.PropTypes.func,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _class2.defaultProps = {
    user: null
}, _temp)) || _class));

exports.default = AddToBasket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/AddToBasket/AddToBasket.jsx
// module id = 1610
// module chunks = 0